export default {
  "Login for users": "Login",
  Login: "Login",
  Password: "Password",
  Submit: "Sign In",
  "Field required": "This field is required",
  "Auth error 400": "Invalid login or password",
  "Auth error network":
    "Connection issue. Please check your internet connection and try again.",
  "Auth error unknown": "Error. Please try again later.",
  "Login title": "Login | AI Opinion",
  "Not account yet": "Don't have an account?",
  "Not account yet about":
    "You can create an account or enter demo mode with limited functionality",
  "Demo-mode": "Demo Mode",
  "Let register": "Register",
  "User Agreement Title": "User Agreement | AI Opinion",
  "User Agreement": "User Agreement",
  "Privacy policy": "Privacy policy",
  "User Agreement About part 1": "To continue, you have to accept the ",
  "User Agreement About part 2": "user agreement.",
  "User Agree": "I accept",
  "Page not found": "Page Not Found",
  "Page not found about":
    "The address is incorrect or the page no longer exists. Return to the main page",
  "Back to main page": "Back to Main Page",
  "Login for users 2":
    "Get full access to the functionality of the AI Opinion platform",
  Step: "Step",
  "Min 8": "At least 8 characters",
  "1 char": "1 letter",
  "1 num": "1 digit",
  "Auth access 1": "I agree to ",
  "Auth access 2": "processing of personal data",
  "Auth access 3": ", I accept the terms ",
  "Auth access 4": "policy",
  "Auth access 5": "and",
  "Auth access 6": "User agreement",
  "Have an account?": "Have an account?",
  "To next": "Next",
  "Reg for users 1": "Create an account",
  "Reg for users 2": "Tell us about yourself",
  "Reg for users 3": "Registration completion",
  "Your last_name": "Your last name",
  "Your first_name": "Your first name",
  "Your middle_name": "Your patronymic",
  "Your company": "The organization you work for",
  "Your position_in_the_company": "Your speciality",
  Back: "Back",
  "Min 2": "At least 2 characters",
  Promo: "Promo code (if available)",
  invitation_1: "From friends / colleagues",
  invitation_2: "Email-newsletter",
  invitation_3: "Search in Google",
  invitation_4: "Another source",
  invitation_5: "Social networks",
  "Where do you know about the platform?":
    "How did you find out about the Platform?",
  "Reg finish": "Register",
  regErrorText: "The user could not be registered. Check the data",
  "Auth banner text":
    "Log in to get full access to the functionality of the Platform",
  "Auth banner text 2": "Log in to increase the number of studies to process",
  "Auth banner text 3": "Get 10 of your research<br/>processed for free",
  "Reg error":
    "Unfortunately, it was not possible to complete the registration due to a technical error. Please try again later",
  "Reg error 400": "The email address is already in use",
  "Rem password": "Enter the email address specified during registration",
  Phone: "Phone",
  "Not valid phone": "Phone is incorrent",
};
